import { Create, SimpleForm, TextInput, required } from "react-admin";
import { GroupedPermissionsInput } from "./GroupedPermissionsInput";

const validateRequired = [required()];

export const RoleCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={validateRequired} fullWidth />
      <TextInput source="description" multiline rows={3} fullWidth />
      <GroupedPermissionsInput source="permissionIds" />
    </SimpleForm>
  </Create>
);
